import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  username: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export const initialValues = {
  username: '',
  password: '',
};

// Google JWT credential decoder utility
export const decodeGoogleCredential = (credential: string) => {
  try {
    // JWT has 3 parts separated by dots: header.payload.signature
    const parts = credential.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decodedPayload = atob(
      paddedPayload.replace(/-/g, '+').replace(/_/g, '/'),
    );

    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Error decoding Google credential:', error);
    return null;
  }
};

// Helper function to extract user info from Google credential
export const extractGoogleUserInfo = (credential: string) => {
  const decoded = decodeGoogleCredential(credential);
  if (!decoded) return null;

  return {
    email: decoded.email,
    name: decoded.name,
    email_verified: decoded.email_verified,
    sub: decoded.sub,
  };
};
